import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router';
import type Transition from '@ember/routing/transition';

/**
 * The classic application approval page has been retired. This route is kept
 * only so existing inbound links keep resolving — it redirects to the new
 * approval surface at `tas/applications/:id/approval`.
 */
export default class AuthenticatedAdminTuitionAssistanceApplicationsShowRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: Transition) {
    const id = transition.to?.params?.['tas_application_id'];
    if (id) {
      this.router.replaceWith('authenticated.admin.tas.applications.approval', id);
    }
  }
}
